import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import { getProductData } from "../../../utils/getUserUtility";

import handleErrorLandings from "../handleErrorLandings";
import OtherInsuranceQuotation from "./OfferDiscount";

const landingId = "CF_OFFER_DISCOUNT";

const onLoad = async ({ session, landedAt, uid, navigate }) => {
  try {
    const prevAnswers = {};
    const prevForm = await getFormSession(
      "cancelation-form",
      session.sessionID
    );
    const landings = prevForm.items;
    landings.forEach((item) => {
      if (item.answers.length > 0) {
        const lastField = item?.answers[0];
        const fieldID = lastField.field.id;
        const lastFieldType = lastField.type;
        const lastFieldAnswers = lastField[lastFieldType]?.value;
        prevAnswers[fieldID] = lastFieldAnswers;
      }
    });
    const { discount, totalPremiumDiscount, totalPremium } = prevForm.metadata;
    if (!discount || !totalPremiumDiscount || !totalPremium) {
      await handleErrorLandings({
        error: `Information for Screen ${landingId} not found in metadata`,
        landingId,
        navigate,
        navigatePath: `/formulario/cancelacion/lealtad?uid=${uid}`,
        message: `[Error Ofrecer Descuento][OFFER_DISCOUNT] Ocurrio un error al pedir la información\nlandingError: ${landingId}\nUID: ${uid}\nSessionID: ${session.sessionID}`,
      });
    }
    const productsToCancel = landings[0];
    const productsField = productsToCancel.answers[0];
    const productType = productsField.type;
    const products = productsField[productType].value;
    const product = products[0];
    const productData = await getProductData(uid, product);


    const periods = {
      month: "mensual",
      "3month": "trimestral",
      "6month": "semestral",
      year: "anual",
    };

    return {
      userId: uid,
      pid: product.id,
      sessionID: session.sessionID,
      pType: product.type,
      ...prevAnswers,
      landedAt,
      prevForm,
      currentLanding: landingId,
      premium: totalPremium,
      discount: discount * 100,
      premiumWithDiscount: totalPremiumDiscount,
      period: periods[productData.period],
    };
  } catch (error) {
    await handleErrorLandings({
      error,
      landingId,
      navigate,
      navigatePath: `/formulario/cancelacion/lealtad?uid=${uid}`,
      message: `[Error Ofrecer Descuento][OFFER_DISCOUNT] Ocurrio un error al pedir la información\nlandingError: ${landingId}\nUID: ${uid}\nSessionID: ${session.sessionID}`,
    });
  }
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(await nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <OtherInsuranceQuotation state={state} setState={setState} />
);

const nextPage = async (props) => {
  return `/formulario/cancelacion/lealtad?uid=${props.uid}`;
};
const prevPage = (props) =>
  `/formulario/cancelacion/otro-seguro-cotizacion?uid=${props.uid}`;

const fieldsStructure = [];

const offerDiscountProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default offerDiscountProps;
